import { Text } from "@wojo/ui";
import React, { useId } from "react";

export type OverviewColumnProps = {
    title: string;
    items?: string[];
};

export const OverviewColumn: React.FC<OverviewColumnProps> = ({
    title,
    items = [],
}) => {
    const titleId = useId();

    if (items.length === 0) {
        return null;
    }

    return (
        <div>
            <Text.Heading order="6" tag="h3" id={titleId}>
                {title}
            </Text.Heading>
            <ul
                aria-labelledby={titleId}
                style={{
                    paddingLeft: "var(--g-spacing-md)",
                    display: "grid",
                    gap: "var(--g-spacing-sm)",
                }}
            >
                {items.map((item, index) => (
                    <Text.Body tag="li" key={`overview-${titleId}-${index}`}>
                        {item}
                    </Text.Body>
                ))}
            </ul>
        </div>
    );
};
